import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';

import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DynamicTableComponent } from '../../dynamic-table/dynamic-table.component';
import { DunaEventInstructorsCreateInvitationModalComponent } from './create-invitation-modal/create-invitation-modal.component';
import { DunaEventInstructorsInvitationDetailModalComponent } from './invitation-detail-modal/invitation-detail-modal.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-duna-event-instructors',
  standalone: true,
  imports: [
    MatCardModule,
    MatButtonModule,
    MatTabsModule,
    MatDialogModule,
    DynamicTableComponent,
  ],
  templateUrl: './duna-event-instructors.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './duna-event-instructors.component.scss',
})
export class DunaEventInstructorsComponent implements OnInit, OnDestroy {
  @ViewChild('eventsTable') eventsTable?: DynamicTableComponent;
  @ViewChild('invitationsTable') invitationsTable?: DynamicTableComponent;

  private destroy$ = new Subject<void>();
  private openListener = (e: Event) =>
    this.handleOpenInvitation(e as CustomEvent);

  constructor(private dialog: MatDialog, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    window.addEventListener(
      'duna-instructor-invitation-open',
      this.openListener as EventListener
    );
  }

  ngOnDestroy(): void {
    window.removeEventListener(
      'duna-instructor-invitation-open',
      this.openListener as EventListener
    );
    this.destroy$.next();
    this.destroy$.complete();
  }

  get selectedEventsCount(): number {
    const table = this.eventsTable;
    if (!table?.selection?.selected?.length) return 0;
    return table.selection.selected.length;
  }

  openCreateInvitationModal(): void {
    const selected = this.eventsTable?.selection?.selected ?? [];
    const eventGuids = selected.map((r: any) => r.guid).filter(Boolean);
    if (eventGuids.length === 0) return;
    const dialogRef = this.dialog.open(
      DunaEventInstructorsCreateInvitationModalComponent,
      {
        width: '1100px',
        maxWidth: '98vw',
        data: { eventGuids, events: selected },
      }
    );
    dialogRef.afterClosed().subscribe(() => {
      this.invitationsTable?.refreshTable?.();
      this.eventsTable?.refreshTable?.();
      this.cdr.detectChanges();
    });
  }

  private handleOpenInvitation(event: CustomEvent): void {
    const row = event.detail as { guid: string; [key: string]: any };
    if (!row?.guid) return;
    if (this.dialog.openDialogs.length > 0) return;
    const dialogRef = this.dialog.open(
      DunaEventInstructorsInvitationDetailModalComponent,
      {
        width: '95vw',
        maxWidth: '1200px',
        exitAnimationDuration: '0ms',
        data: {
          invitationGuid: row.guid,
          onDeleteSuccess: () => {
            setTimeout(() => {
              this.invitationsTable?.refreshTable?.();
              this.eventsTable?.refreshTable?.();
              this.cdr.detectChanges();
            }, 0);
          },
        },
      }
    );
    dialogRef.afterClosed().subscribe(() => {
      setTimeout(() => {
        this.invitationsTable?.refreshTable?.();
        this.eventsTable?.refreshTable?.();
        this.cdr.detectChanges();
      }, 0);
    });
  }
}
